import { LoadingButton } from '@mui/lab';
import React, { useContext } from 'react';
import { useMutation } from '@apollo/client';
import { SeasonShowContext } from '../../Providers/SeasonShowProvider';
import { SnackbarContext } from '../../Providers/SnackbarProvider';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { Error } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { graphql } from 'gql';
import { namedOperations } from 'gql/graphql';

const CascadeDeleteShow = graphql(`
    mutation CascadeDeleteShow_DeleteShowDialog($showId: ID!) {
        cascadeDeleteShow(showId: $showId) {
            nodesDeleted
            relationshipsDeleted
        }
    }`);

type Props = {
    open: boolean;
    onClose: () => void;
}

export default function DeleteShowDialog({ open, onClose }: Props) {
    const navigate = useNavigate();

    const { selectedShow, setSelectedShow, setSelectedSeason } = useContext(SeasonShowContext);
    const { success, error } = useContext(SnackbarContext);

    const [deleteShow, { loading }] = useMutation(CascadeDeleteShow);

    const handleYes = async () => {
        try {
            await deleteShow({
                variables: { showId: selectedShow!.id },
                refetchQueries: [
                    namedOperations.Query.GetShows_SeasonShowProvider,
                    namedOperations.Query.GetSeasonFromShow_SeasonShowProvider,
                    namedOperations.Query.GetEpisodesForSeason_Layout,
                    namedOperations.Query.EpisodeLines,
                ],
            });
            setSelectedShow(null);
            setSelectedSeason(null);
            navigate('/');
            onClose();
            success('Show deleted');
        } catch (e) {
            // @ts-ignore
            error('Failed to delete show. ' + e.message);
        }
    }

    if (!selectedShow) {
        return null;
    }

    return (
        <Dialog open={open}>
            <DialogTitle>Delete Show</DialogTitle>
            <DialogContent>
                <Typography>Are you sure you want to delete the show {selectedShow.title}?</Typography>
                <Typography color='error' variant='caption'>It will be gone forever!</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant='text' color='inherit'>No</Button>
                <LoadingButton
                    onClick={handleYes}
                    startIcon={<Error />}
                    variant='text'
                    color='error'
                    loading={loading}
                >
                    Yes
                </LoadingButton>
            </DialogActions>
        </Dialog>
    )
}